import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Container, Icon } from "semantic-ui-react";

class AssignContractorEvent extends React.Component {
  static propTypes = {
    date: PropTypes.string,
    user: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { date, user, name } = this.props;

    return (
      <div data-component="timelineItem" data-event="contractor_unassigned">
        <div className="bullet-pointer">
          <Icon size="large" circular color="grey" name="shipping" />
          <Icon color="red" name="remove" className="corner" />
        </div>
        <Container data-component="logDetails">
          <time>{date}</time>{" "}
          <FormattedMessage
            id="activity.timeline.event.unassignContractor"
            defaultMessage="activity.timeline.event.unassignContractor"
            values={{ name }}
          />
          <div className="user">{user}</div>
        </Container>
      </div>
    );
  }
}

export default AssignContractorEvent;
